export default __webpack_public_path__ + "static/media/Label_Trial_1.51ab4053.svg";